import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { FaGithub, FaLinkedinIn, FaInstagram, FaFileAlt } from "react-icons/fa";
import "../pages_css/Contact.css";

const resumeFile = "/Vaibhav_Kapoor_Resume___.docx";

const ROLES = [
  "Frontend Developer",
  "React Developer",
  "Web Developer",
  "Shopify Developer",
  "Full-Stack (Jr.)",
];

const SOCIALS = [
  {
    Icon: FaGithub,
    label: "GitHub",
    handle: "@vaibhavkapoor7",
    url: "https://github.com/vaibhavkapoor7",
  },
  {
    Icon: FaLinkedinIn,
    label: "LinkedIn",
    handle: "vaibhav-kapoor",
    url: "https://www.linkedin.com/in/vaibhav-kapoor-3-4-2006-vk",
  },
  {
    Icon: FaInstagram,
    label: "Instagram",
    handle: "@vaibhavkapoor___3",
    url: "https://www.instagram.com/vaibhavkapoor___3?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
  },
];

function Contact() {
  const email = "kapoorvaibhav66@gmail.com";
  const [copied, setCopied] = useState(false);
  const timerRef = useRef(null);
  useEffect(() => () => clearTimeout(timerRef.current), []);

  const handleCopy = async () => {
    try { await navigator.clipboard.writeText(email); } catch {}
    setCopied(true);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setCopied(false), 1800);
  };

  return (
    <section className="contact-page">
      <Link to="/" className="back-home">← Back to home</Link>

      <div className="contact-content">

        {/* HEADER */}
        <div className="contact-header">
          <div className="contact-avail">
            <span className="avail-dot" />
            Open to Work &nbsp;·&nbsp; Actively Looking
          </div>
          <h1>
            Let's find<br />
            <span className="h1-accent">the right fit.</span>
          </h1>
          <p className="contact-lead">
            I'm a frontend &amp; web developer looking for my next opportunity.
            If you think I'd be a good fit for your team, let's talk.
          </p>
        </div>

        {/* ROLES I'M OPEN TO */}
        <div className="roles-section">
          <span className="roles-label">Open to roles in</span>
          <div className="roles-pills">
            {ROLES.map((role) => (
              <span key={role} className="role-pill">{role}</span>
            ))}
          </div>
        </div>

        {/* RESUME CARD */}
        <div className="resume-card">
          <div className="resume-card__left">
            <span className="resume-card__icon"><FaFileAlt /></span>
            <div className="resume-card__text">
              <span className="resume-card__label">Resume</span>
              <span className="resume-card__desc">
                Skills, experience &amp; projects — ready to download.
              </span>
            </div>
          </div>
          <a
            href={resumeFile}
            download="Vaibhav_Kapoor_Resume.docx"
            className="resume-btn"
          >
            Download Resume
          </a>
        </div>

        {/* EMAIL CARD */}
        <div className="contact-email-wrap">
          <span className="email-micro-label">Job Inquiries</span>
          <div className="email-row">
            <a href={`mailto:${email}`} className="email-address">{email}</a>
            <button
              type="button"
              className={`copy-btn${copied ? " copied" : ""}`}
              onClick={handleCopy}
            >
              {copied ? "Copied!" : "Copy"}
            </button>
          </div>
          <span className="email-note">Usually responds within 24 hours</span>
        </div>

        {/* DIVIDER */}
        <div className="contact-or">
          <span>or find me on</span>
        </div>

        {/* SOCIAL GRID */}
        <div className="social-grid">
          {SOCIALS.map(({ Icon, label, handle, url }) => (
            <a
              key={label}
              href={url}
              target="_blank"
              rel="noreferrer"
              className={`social-card${label === "LinkedIn" ? " social-card--featured" : ""}`}
            >
              <span className="social-card__icon"><Icon /></span>
              <span className="social-card__name">{label}</span>
              <span className="social-card__handle">{handle}</span>
              <span className="social-card__arrow">↗</span>
            </a>
          ))}
        </div>

      </div>

    </section>
  );
}

export default Contact;
